export const StaffProfilesActionTypes = {
    API_RESPONSE_SUCCESS: '@@staffProfiles/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@staffProfiles/API_RESPONSE_ERROR',

    LIST_STAFF_PROFILES: '@@stastaffProfilesff/LIST_STAFF_PROFILES',

    RESET: '@@staffProfiles/RESET',
};
